import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const VisualProofSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  // Elise's actual images
  const images = [
    {
      src: "https://customer-assets.emergentagent.com/job_fccba908-50a0-4b6a-ab3b-18e81971b59f/artifacts/8dxyy0ty_IMG_1446.jpeg",
      alt: "Elise Redfield - Waterfall Strength",
      featured: true
    },
    {
      src: "https://customer-assets.emergentagent.com/job_a514c27e-db5e-47bd-9e0a-eca1897bc21e/artifacts/zibevjww_elise2.jpeg",
      alt: "Elise Redfield - Barbell Squat",
      featured: false
    },
    {
      src: "https://customer-assets.emergentagent.com/job_fccba908-50a0-4b6a-ab3b-18e81971b59f/artifacts/3xnks34x_IMG_6621.jpg",
      alt: "Elise Redfield - Hammer Strength",
      featured: false
    },
    {
      src: "https://customer-assets.emergentagent.com/job_a514c27e-db5e-47bd-9e0a-eca1897bc21e/artifacts/kxcwvju2_elise3.jpeg",
      alt: "Elise Redfield - Iron Alliance",
      featured: false
    }
  ];

  return (
    <section 
      ref={ref}
      className="py-24 md:py-40 px-6 md:px-12 bg-bone"
      data-testid="visual-proof-section"
    >
      <div className="max-w-screen-2xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-12 md:mb-20 text-center"
        >
          <p className="font-body text-xs tracking-[0.3em] uppercase text-graphite/50 mb-4">
            Visual Proof
          </p>
          <h2 
            className="font-heading text-4xl md:text-6xl font-bold tracking-tight uppercase text-graphite-dark"
            data-testid="visual-proof-title"
          >
            Controlled Power
          </h2>
        </motion.div>

        {/* Photo Grid - Masonry Style */}
        <div className="photo-grid">
          {images.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="photo-item img-container"
              data-testid={`visual-proof-image-${index}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-auto object-cover img-grayscale"
                loading="lazy"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisualProofSection;
